var _path, _rect, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMotor = function SvgMotor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M22.5 59v22.5C22.5 99.45 37.05 114 55 114h1.25c17.259 0 31.25-13.991 31.25-31.25V66.5c0-8.284-6.716-15-15-15h-8.75a6.25 6.25 0 0 0-6.25 6.25v0A6.25 6.25 0 0 0 63.75 64h8.793C73.9 64 75 65.1 75 66.457v3.165c0 1.037-.84 1.878-1.878 1.878v0c-8.628 0-15.622 6.994-15.622 15.622V94"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.5,
    height: 25,
    x: 22.5,
    y: 44,
    stroke: "#7B4EF8",
    strokeWidth: 3,
    rx: 6.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.5,
    height: 25,
    x: 35,
    y: 44,
    stroke: "#7B4EF8",
    strokeWidth: 3,
    rx: 6.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeWidth: 3,
    d: "M64.67 51.814 53.25 21.276a6.25 6.25 0 1 1 11.708-4.378l13.686 36.604"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeWidth: 3,
    d: "m47.537 57.511 9.645-25.537M63.61 14.96l1.01-2.675a6.25 6.25 0 1 1 11.694 4.417l-5.226 13.836-.617 1.633"
  })));
};
export default SvgMotor;